(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsxs as l, jsx as a, Fragment as V } from "react/jsx-runtime";
import { useI18n as g } from "next-localization";
import { NeuButton as O, NeuIcon as ae, NeuModal as E, NeuFeedback as T, NeuCard as pe, NeuSnackbar as ye } from "@hcahealthcaredpx/neutron-react";
import { o as z, s as P, Z as b, a as D, u as Ce } from "../../chunks/types.BJMlOVBS.js";
import { T as k, P as ge } from "../../chunks/page-content.B0ugSU6N.js";
import { RichText as R, withDatasourceCheck as be } from "@sitecore-jss/sitecore-jss-nextjs";
import { u as v } from "../../chunks/use-connected-relationship-info.DvMNYpDA.js";
import { createContext as Me, useContext as Fe, useEffect as q, useCallback as $, useState as M, useMemo as se } from "react";
import { M as w } from "../../chunks/modifiable-list.C-OdvAIi.js";
import { useFormContext as Ne, useForm as B } from "react-hook-form";
import { a as S, F as A, b as ne } from "../../chunks/form-wrapper.CxSd-0ur.js";
import { C as te, F as G } from "../../chunks/form-mask-input.92EW49hv.js";
import { c as L } from "../../chunks/clsx.OuTLNxxd.js";
import { u as oe, a as ie } from "../../chunks/use-update-account.Cr_jUcK8.js";
import { useMutation as _ } from "@tanstack/react-query";
import { a as X } from "../../chunks/api.DHdhNbok.js";
import { saveTimestampToLocalStorage as J } from "../../utils/storage/index.js";
import { u as ce } from "../../chunks/useNetworkStatus.B65eRjoK.js";
import { c as Oe } from "../../chunks/use-account.DkVfV1FC.js";
const de = Me({
  userMyHealthOneId: "",
  searchPhysicianErrorMessageField: { value: "" },
  noPhysicianErrorMessageField: { value: "" },
  searchPharmacyErrorMessageField: { value: "" },
  noPharmacyErrorMessageField: { value: "" },
  showProfileChangeSnackbar: () => null
}), x = () => {
  const r = Fe(de);
  if (!r)
    throw new Error(
      "useCarePreferencesContext must be used within a CarePreferencesContext.Provider"
    );
  return r;
}, f = {
  name: /^([a-zA-Z ',&.-]){1,100}$/,
  address: /^([a-z0-9A-Z ',#.-]){1,50}$/,
  state: /^([a-z0-9A-Z ',#.-]){1,25}$/,
  city: /^([a-z0-9A-Z ',#.-]){1,25}$/,
  zipCode: /^\d{5}(-\d{4})?$/,
  phone: /^\(\d{3}\)\d{3}-\d{4}$/
}, le = (r) => {
  const { city: e, state: s, zip: n } = r;
  return !!e && !!s && !!n ? `${e} ${s}, ${n}` : "";
}, K = {
  physician: "api/accounts/physician",
  physicianSearch: "api/organization/physician/search",
  pharmacy: "api/accounts/pharmacy",
  pharmacySearch: "api/organization/pharmacy/search"
}, me = async (r, e) => {
  J();
  const s = e ? `?connectedRelUsername=${encodeURIComponent(e)}` : "";
  if (!(await X.delete(K[r] + s)).ok)
    throw new Error(`Problem deleting user ${r}!`);
}, Se = async (r) => {
  J();
  const e = await X.post(K.physicianSearch, r);
  if (!e.ok)
    throw new Error("Problem posting primary care physician search!");
  return e.json();
}, He = async (r) => {
  J();
  const e = await X.post(K.pharmacySearch, r);
  if (!e.ok)
    throw new Error("Problem posting pharmacy search!");
  return e.json();
}, Le = (r) => _({
  ...r,
  mutationFn: (e) => He(e)
}), I = ({ className: r, onCancel: e, primaryButton: s }) => {
  const { t: n } = g();
  return /* @__PURE__ */ l(
    "div",
    {
      className: L("w-100 d-flex flex-row gap-1 align-items-end justify-content-end", r),
      children: [
        /* @__PURE__ */ a(O, { className: "link-btn", type: "button", kind: "tertiary", onClick: e, children: n("MHO.Profile.CarePreferences.Form.Labels.Cancel") }),
        s
      ]
    }
  );
}, h = {
  addressLine1: "addressLine1",
  addressLine2: "addressLine2",
  city: "city",
  state: "state",
  zip: "zip"
}, he = ({ isRequired: r }) => {
  const { t: e } = g(), { clearErrors: s } = Ne(), { data: n = [] } = oe({
    options: {
      isAbbreviationAsLabel: !0
    }
  });
  return q(() => {
    r || s(Object.values(h));
  }, [r]), /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a("h6", { className: "fw-bold", children: e("MHO.Profile.CarePreferences.Form.Labels.Address.Address") }),
    /* @__PURE__ */ a(
      S,
      {
        name: h.addressLine1,
        label: e("MHO.Profile.CarePreferences.Form.Labels.Address.Address1"),
        placeholder: e("MHO.Profile.CarePreferences.Form.Labels.Address.EnterAddress"),
        required: r,
        maxLength: 50
      }
    ),
    /* @__PURE__ */ a(
      S,
      {
        name: h.addressLine2,
        label: e("MHO.Profile.CarePreferences.Form.Labels.Address.Address2"),
        placeholder: e("MHO.Profile.CarePreferences.Form.Labels.Address.EnterAddress"),
        maxLength: 50
      }
    ),
    /* @__PURE__ */ l(A.Row, { className: "gap-3", children: [
      /* @__PURE__ */ a(
        S,
        {
          name: h.city,
          label: e("MHO.Profile.CarePreferences.Form.Labels.City"),
          placeholder: e("MHO.Profile.CarePreferences.Form.Labels.Address.EnterCity"),
          required: r,
          maxLength: te
        }
      ),
      /* @__PURE__ */ a(
        ne,
        {
          name: h.state,
          label: e("MHO.Profile.CarePreferences.Form.Labels.State"),
          items: n,
          required: r
        }
      ),
      /* @__PURE__ */ a(
        G,
        {
          name: h.zip,
          label: e("MHO.Profile.CarePreferences.Form.Labels.Address.Zipcode"),
          placeholder: e("MHO.Profile.CarePreferences.Form.Labels.EnterZipcode"),
          format: "zip",
          required: r
        }
      )
    ] })
  ] });
}, Ae = (r) => z({
  pharmacyName: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredPharmacyName") }).regex(f.name, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidPharmacyName")
  }),
  pharmacyPhone: P().min(1, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredPharmacyPhoneNumber")
  }).regex(f.phone, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidPhoneNumber")
  }),
  addressLine2: P().refine((e) => e.length ? f.address.test(e) : !0, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidAddress2")
  }),
  addressLine1: P(),
  city: P(),
  state: P(),
  zip: P()
}).superRefine((e, s) => {
  const { addressLine1: n, addressLine2: t, city: o, state: c, zip: d } = e;
  [n, t, o, c, d].some(
    (u) => !!u
  ) && (n.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredAddress1"),
    path: [h.addressLine1]
  }), o.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredCity"),
    path: [h.city]
  }), c.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredState"),
    path: [h.state]
  }), d.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredZipcode"),
    path: [h.zip]
  }), n.length && !f.address.test(n) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidAddress1"),
    path: [h.addressLine1]
  }), o.length && !f.city.test(o) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidCity"),
    path: [h.city]
  }), c.length && !f.state.test(c) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidState"),
    path: [h.state]
  }), d.length && !f.zipCode.test(d) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidZipcode"),
    path: [h.zip]
  }));
}), ee = {
  pharmacyName: "pharmacyName",
  pharmacyPhone: "pharmacyPhone"
}, Ve = ({ onSubmit: r, onClose: e }) => {
  const { t: s } = g(), { connectedRelUsername: n } = v(), { userMyHealthOneId: t } = x(), o = $(() => Ae(s), [s]), c = B({
    mode: "all",
    defaultValues: {
      pharmacyName: "",
      pharmacyPhone: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    },
    resolver: D(o())
  }), { watch: d, trigger: m } = c, y = d(Object.values(h)).some((C) => !!C);
  return /* @__PURE__ */ a("div", { className: "pt-1 pb-3 overflow-auto", children: /* @__PURE__ */ l(
    A,
    {
      onSubmit: ({
        pharmacyName: C,
        pharmacyPhone: F,
        addressLine1: N,
        addressLine2: p,
        city: H,
        state: j,
        zip: Z
      }) => {
        r({ ...{
          user: {
            myHealthOneId: t
          },
          userPharmacy: {
            pharmacyId: "0",
            pharmacyName: C,
            pharmacyPhone: F,
            pharmacyAddress: {
              addressLine1: N,
              addressLine2: p,
              city: H,
              country: "",
              state: j,
              zip: Z
            }
          }
        }, connectedRelUsername: n });
      },
      methods: c,
      showButtons: !1,
      className: "h-224 h-sm-auto",
      children: [
        /* @__PURE__ */ a(
          S,
          {
            name: ee.pharmacyName,
            label: s("MHO.Profile.CarePreferences.Pharmacy.PharmacyName"),
            placeholder: s("MHO.Profile.CarePreferences.Form.Labels.EnterName"),
            required: !0
          }
        ),
        /* @__PURE__ */ a(
          G,
          {
            name: ee.pharmacyPhone,
            label: s("MHO.Profile.CarePreferences.Pharmacy.PharmacyPhoneNumber"),
            placeholder: s("MHO.Profile.CarePreferences.Form.Labels.EnterNumber"),
            format: "phone",
            required: !0
          }
        ),
        /* @__PURE__ */ a(he, { isRequired: y }),
        /* @__PURE__ */ a(
          I,
          {
            className: "pb-3 pb-sm-0",
            onCancel: e,
            primaryButton: /* @__PURE__ */ a(O, { type: "submit", kind: "primary", onClick: () => m(), children: s("MHO.Profile.CarePreferences.Form.Labels.Save") })
          }
        )
      ]
    }
  ) });
}, ue = ({ setErrorMessage: r }) => {
  const { t: e } = g(), { data: s = [], error: n } = oe({
    options: {
      isAbbreviationAsLabel: !0
    }
  });
  return q(() => {
    r(n == null ? void 0 : n.toString());
  }, [n]), /* @__PURE__ */ l(A.Row, { className: "gap-3", children: [
    /* @__PURE__ */ a(
      S,
      {
        name: h.city,
        label: e("MHO.Profile.CarePreferences.Form.Labels.City"),
        placeholder: e("MHO.Profile.CarePreferences.Form.Labels.Address.EnterCity"),
        required: !0,
        maxLength: te
      }
    ),
    /* @__PURE__ */ a(
      ne,
      {
        "aria-live": "polite",
        name: h.state,
        label: e("MHO.Profile.CarePreferences.Form.Labels.State"),
        required: !0,
        items: s
      }
    )
  ] });
}, re = {
  pharmacyName: "pharmacyName",
  city: "city",
  state: "state"
}, xe = (r) => z({
  pharmacyName: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredPharmacyName") }).regex(f.name, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidPharmacyName")
  }),
  city: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredCity") }).regex(f.city, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidCity")
  }),
  state: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredState") }).regex(f.state, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidState")
  })
}), ve = ({ onSearch: r, onClose: e }) => {
  const { t: s } = g(), [n, t] = M(void 0), o = $(() => xe(s), [s]), c = B({
    mode: "all",
    defaultValues: {
      pharmacyName: "",
      city: "",
      state: ""
    },
    resolver: D(o())
  }), { watch: d } = c, u = d(Object.values(re)).every((i) => i !== "");
  return /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a(
      k,
      {
        className: "mx-3 my-1",
        kind: "error",
        showAlert: !!n,
        durationInSeconds: 10,
        children: n
      }
    ),
    /* @__PURE__ */ a("div", { className: "pt-1 pb-3 overflow-visible", children: /* @__PURE__ */ l(A, { onSubmit: ({ pharmacyName: i, city: C, state: F }) => {
      r({
        pharmacyName: i,
        city: C,
        state: F
      });
    }, methods: c, showButtons: !1, children: [
      /* @__PURE__ */ a(A.Row, { className: "gap-3", children: /* @__PURE__ */ a(
        S,
        {
          name: re.pharmacyName,
          label: s("MHO.Profile.CarePreferences.Pharmacy.Pharmacy"),
          required: !0
        }
      ) }),
      /* @__PURE__ */ a(ue, { setErrorMessage: t }),
      /* @__PURE__ */ a(
        I,
        {
          onCancel: e,
          primaryButton: /* @__PURE__ */ a(O, { type: "submit", kind: "primary", disabled: !u, children: s("MHO.Profile.CarePreferences.Form.Labels.Search") })
        }
      )
    ] }) })
  ] });
}, we = "_searchItem_1nfzp_5", Ee = "_noItemErrorMessage_1nfzp_9", Q = {
  searchItem: we,
  noItemErrorMessage: Ee
}, Pe = ({ name: r, address: e, phone: s, buttonText: n, onClick: t }) => {
  const { t: o } = g();
  return /* @__PURE__ */ l(
    "div",
    {
      className: L(
        Q.searchItem,
        "w-100 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-3 border border-neu-gray-20 rounded gap-2"
      ),
      children: [
        /* @__PURE__ */ l("div", { className: "d-flex flex-column text-capitalize", children: [
          /* @__PURE__ */ a("h4", { className: "fw-bold neu-display-6", children: r }),
          /* @__PURE__ */ a("span", { children: e.addressLine1 }),
          !!e.addressLine2 && /* @__PURE__ */ a("span", { children: e.addressLine2 }),
          /* @__PURE__ */ a("span", { children: `${e.city} ${e.state}, ${e.zip}` }),
          s && /* @__PURE__ */ l("span", { children: [
            "Phone:",
            " ",
            /* @__PURE__ */ a("a", { href: `tel:${s}`, className: "text-decoration-none", children: s })
          ] })
        ] }),
        /* @__PURE__ */ a(O, { onClick: t, className: "w-100 w-md-auto", children: o(n) })
      ]
    }
  );
}, ke = ({
  hasSearchError: r,
  searchResult: e,
  onSelect: s,
  setComponentStep: n
}) => {
  const { t } = g(), { connectedRelUsername: o } = v(), { userMyHealthOneId: c, searchPharmacyErrorMessageField: d, noPharmacyErrorMessageField: m } = x(), u = (i) => {
    const C = {
      user: {
        myHealthOneId: c
      },
      userPharmacy: {
        ...i,
        pharmacyPhone: i.pharmacyPhone ?? "",
        pharmacyAddress: {
          addressLine1: i.pharmacyAddress.addressLine1,
          addressLine2: i.pharmacyAddress.addressLine2,
          city: i.pharmacyAddress.city,
          country: i.pharmacyAddress.country ?? "",
          state: i.pharmacyAddress.state,
          zip: i.pharmacyAddress.zip
        }
      }
    };
    s({ ...C, connectedRelUsername: o });
  }, y = !!e && e.length > 0;
  return /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: L("pt-1 p-3 overflow-auto", {
          "pb-0 border-top border-neu-gray-20 neu-bg-gray-0": y
        }),
        children: /* @__PURE__ */ l("div", { className: "d-flex flex-column row-gap-3", children: [
          r && !e && /* @__PURE__ */ l("div", { className: "d-flex column-gap-3 p-4 border rounded border-neu-red-60 neu-bg-red-0", children: [
            /* @__PURE__ */ a(ae, { className: "neu-snackbar__feedback-icon", name: "error", color: "red-50" }),
            /* @__PURE__ */ a(R, { field: d })
          ] }),
          /* @__PURE__ */ l("div", { className: "w-100 d-flex flex-row align-items-center justify-content-between", children: [
            /* @__PURE__ */ l("span", { children: [
              e ? e.length : "0",
              " Results Found"
            ] }),
            /* @__PURE__ */ a(
              O,
              {
                className: "link-btn",
                type: "button",
                kind: "tertiary",
                icon: "edit",
                onClick: () => n("searchForm"),
                children: t("MHO.Profile.CarePreferences.Form.Labels.EditSearch")
              }
            )
          ] }),
          y && /* @__PURE__ */ a("div", { className: "d-flex flex-column row-gap-3 pb-3 max-h-224 max-h-272-md", children: e.map((i) => /* @__PURE__ */ a(
            Pe,
            {
              name: i.pharmacyName,
              address: i.pharmacyAddress,
              phone: i.pharmacyPhone,
              buttonText: "MHO.Profile.CarePreferences.Pharmacy.SelectPharmacy",
              onClick: () => u(i)
            },
            i.pharmacyId
          )) })
        ] })
      }
    ),
    /* @__PURE__ */ l(
      "div",
      {
        className: L("pb-3 px-3", {
          "pt-3 border-top border-neu-gray-20": y
        }),
        children: [
          !!e && e.length === 0 && /* @__PURE__ */ a(
            R,
            {
              className: L("mb-5", Q.noItemErrorMessage),
              field: m
            }
          ),
          /* @__PURE__ */ a(
            O,
            {
              kind: "secondary",
              className: "w-100 w-md-auto",
              onClick: () => n("manualAddForm"),
              children: t("MHO.Profile.CarePreferences.Pharmacy.MyPharmacyIsNotListed")
            }
          )
        ]
      }
    )
  ] });
}, Ie = ({ isOpen: r, onClose: e }) => {
  const { t: s } = g(), [n, t] = M("searchForm"), [o, c] = M(""), [d, m] = M(!1), [u, y] = M(null), { showProfileChangeSnackbar: i } = x(), { mutate: C } = Le({
    onMutate: () => {
      t("loading");
    },
    onSuccess: (p) => {
      m(!1), y(p.data.results), t("searchList");
    },
    onError: () => {
      m(!0), y(null), t("searchList");
    }
  }), { mutate: F } = ie({
    onMutate: () => {
      t("loading");
    },
    onSuccess: () => {
      e(), i();
    },
    onError: (p) => {
      const H = typeof p == "object" && p !== null && "message" in p ? p.message ?? "" : "";
      c(H), t("manualAddForm");
    }
  }), N = se(() => ({
    loading: {
      label: "",
      component: /* @__PURE__ */ a(T, { className: "pb-6", kind: "spinner" })
    },
    searchForm: {
      label: "MHO.Profile.CarePreferences.Pharmacy.FindYourPharmacy",
      component: /* @__PURE__ */ a(ve, { onSearch: C, onClose: e })
    },
    searchList: {
      label: "MHO.Profile.CarePreferences.Pharmacy.FindYourPharmacy",
      component: /* @__PURE__ */ a(
        ke,
        {
          hasSearchError: d,
          searchResult: u,
          onSelect: F,
          setComponentStep: t
        }
      )
    },
    manualAddForm: {
      label: "MHO.Profile.CarePreferences.Pharmacy.PharmacyTitle",
      component: /* @__PURE__ */ a(Ve, { onSubmit: F, onClose: e })
    }
  })[n], [n]);
  return q(() => {
    if (r) return;
    const p = setTimeout(() => {
      t("searchForm");
    }, 250);
    return () => clearTimeout(p);
  }, [r]), /* @__PURE__ */ l(
    E,
    {
      active: r,
      onNeuDismiss: e,
      backdropDismiss: !1,
      label: s(N.label),
      size: "large",
      children: [
        /* @__PURE__ */ a(
          k,
          {
            className: "mx-3 my-1",
            kind: "error",
            showAlert: !!o,
            durationInSeconds: 10,
            children: o
          }
        ),
        N.component
      ]
    },
    N.label
  );
}, Re = (r) => _({
  ...r,
  mutationFn: (e) => me("pharmacy", e.connectedRelUsername)
}), fe = ({ description: r, onClose: e, onConfirm: s }) => {
  const { t: n } = g();
  return /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a(E.Content, { children: /* @__PURE__ */ a("p", { children: n(r) }) }),
    /* @__PURE__ */ a(E.Footer, { children: /* @__PURE__ */ a(
      I,
      {
        onCancel: e,
        primaryButton: /* @__PURE__ */ a(O, { color: "blue", onClick: s, children: n("MHO.Profile.CarePreferences.Form.Labels.Yes") })
      }
    ) })
  ] });
}, Te = ({ isOpen: r, onClose: e }) => {
  const { t: s } = g(), { isOnline: n } = ce(), { connectedRelUsername: t } = v(), { showProfileChangeSnackbar: o } = x(), {
    mutate: c,
    isPending: d,
    error: m
  } = Re({
    onSuccess: () => {
      e(), o();
    }
  });
  return /* @__PURE__ */ l(
    E,
    {
      active: r,
      onNeuDismiss: e,
      backdropDismiss: !d,
      label: s("MHO.Profile.CarePreferences.Pharmacy.RemovePharmacyTitle"),
      children: [
        /* @__PURE__ */ a(
          k,
          {
            className: "mx-3 my-1",
            kind: "error",
            showAlert: !!(m != null && m.message),
            durationInSeconds: 10,
            children: m == null ? void 0 : m.message
          }
        ),
        d ? /* @__PURE__ */ a(T, { className: "pb-6", kind: "spinner" }) : /* @__PURE__ */ a(
          fe,
          {
            description: "MHO.Profile.CarePreferences.Pharmacy.RemovePharmacyDescription",
            onClose: e,
            onConfirm: n ? () => c({ connectedRelUsername: t }) : () => null
          }
        )
      ]
    }
  );
}, ze = ({
  pharmacyTitleValue: r,
  userPharmacy: e,
  refetchUserPersonalInformationData: s
}) => {
  const { t: n } = g(), [t, o] = M(!1), [c, d] = M(!1), m = () => {
    s(), d(!1);
  }, u = () => {
    s(), o(!1);
  };
  return /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ a(w, { headerText1: r, children: e && e.pharmacyName ? /* @__PURE__ */ a(
      w.Item,
      {
        itemText1: e.pharmacyName,
        itemSubText: /* @__PURE__ */ l(V, { children: [
          /* @__PURE__ */ a("p", { children: e.pharmacyPhone }),
          /* @__PURE__ */ l("p", { className: "text-capitalize", children: [
            e.pharmacyAddress.addressLine1,
            " ",
            e.pharmacyAddress.addressLine2 && `, ${e.pharmacyAddress.addressLine2}`
          ] }),
          /* @__PURE__ */ a("p", { className: "text-capitalize", children: le(e.pharmacyAddress) })
        ] }),
        onEditButtonClick: () => o(!0),
        onDeleteButtonClick: () => d(!0)
      }
    ) : /* @__PURE__ */ a(
      w.AddButton,
      {
        text: n("MHO.Profile.CarePreferences.Pharmacy.AddPharmacy"),
        onClick: () => o(!0)
      }
    ) }),
    /* @__PURE__ */ a(Ie, { isOpen: t, onClose: u }),
    /* @__PURE__ */ a(Te, { isOpen: c, onClose: m })
  ] });
}, De = (r) => _({
  ...r,
  mutationFn: (e) => Se(e)
}), qe = (r) => z({
  firstName: P().min(1, { message: r("Mho.PageContent.Profile.EmergencyContact.Validation.FirstName") }).regex(f.name, {
    message: r("Mho.PageContent.Profile.EmergencyContact.Validation.ValidFirstName")
  }),
  lastName: P().min(1, { message: r("Mho.PageContent.Profile.EmergencyContact.Validation.LastName") }).regex(f.name, {
    message: r("Mho.PageContent.Profile.EmergencyContact.Validation.ValidLastName")
  }),
  phone: P().min(1, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredOfficePhoneNumber")
  }).regex(f.phone, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidPhoneNumber")
  }),
  addressLine2: P().refine((e) => e.length ? f.address.test(e) : !0, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidAddress2")
  }),
  addressLine1: P(),
  city: P(),
  state: P(),
  zip: P()
}).superRefine((e, s) => {
  const { addressLine1: n, addressLine2: t, city: o, state: c, zip: d } = e;
  [n, t, o, c, d].some(
    (u) => !!u
  ) && (n.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredAddress1"),
    path: [h.addressLine1]
  }), o.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredCity"),
    path: [h.city]
  }), c.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredState"),
    path: [h.state]
  }), d.length || s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredZipcode"),
    path: [h.zip]
  }), n.length && !f.address.test(n) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidAddress1"),
    path: [h.addressLine1]
  }), o.length && !f.city.test(o) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidCity"),
    path: [h.city]
  }), c.length && !f.state.test(c) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidState"),
    path: [h.state]
  }), d.length && !f.zipCode.test(d) && s.addIssue({
    code: b.custom,
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidZipcode"),
    path: [h.zip]
  }));
}), U = {
  firstName: "firstName",
  lastName: "lastName",
  phone: "phone"
}, $e = ({ onSubmit: r, onClose: e }) => {
  const { t: s } = g(), { connectedRelUsername: n } = v(), { userMyHealthOneId: t } = x(), o = $(() => qe(s), [s]), c = B({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      phone: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: ""
    },
    resolver: D(o())
  }), { watch: d, trigger: m } = c, y = d(Object.values(h)).some((C) => !!C);
  return /* @__PURE__ */ a("div", { className: "pt-1 pb-3 overflow-auto", children: /* @__PURE__ */ l(
    A,
    {
      onSubmit: ({
        firstName: C,
        lastName: F,
        phone: N,
        addressLine1: p,
        addressLine2: H,
        city: j,
        state: Z,
        zip: W
      }) => {
        r({ ...{
          user: {
            myHealthOneId: t
          },
          userPhysician: {
            nationalProviderIdentifier: "0",
            physicianFirstName: C,
            physicianLastName: F,
            physicianPhone: N,
            address: {
              addressLine1: p,
              addressLine2: H,
              city: j,
              country: "",
              state: Z,
              zip: W
            }
          }
        }, connectedRelUsername: n });
      },
      methods: c,
      showButtons: !1,
      className: "h-224 h-sm-auto",
      children: [
        /* @__PURE__ */ a(
          S,
          {
            name: U.firstName,
            label: s("MHO.Profile.CarePreferences.PrimaryCarePhysician.PhysicianFirstname"),
            placeholder: s("MHO.Profile.CarePreferences.Form.Labels.EnterName"),
            required: !0
          }
        ),
        /* @__PURE__ */ a(
          S,
          {
            name: U.lastName,
            label: s("MHO.Profile.CarePreferences.PrimaryCarePhysician.PhysicianLastname"),
            placeholder: s("MHO.Profile.CarePreferences.Form.Labels.EnterName"),
            required: !0
          }
        ),
        /* @__PURE__ */ a(
          G,
          {
            name: U.phone,
            label: s("MHO.Profile.CarePreferences.PrimaryCarePhysician.OfficePhoneNumber"),
            placeholder: s("MHO.Profile.CarePreferences.Form.Labels.EnterNumber"),
            format: "phone",
            required: !0
          }
        ),
        /* @__PURE__ */ a(he, { isRequired: y }),
        /* @__PURE__ */ a(
          I,
          {
            className: "pb-3 pb-sm-0",
            onCancel: e,
            primaryButton: /* @__PURE__ */ a(O, { type: "submit", kind: "primary", onClick: () => m(), children: s("MHO.Profile.CarePreferences.Form.Labels.Save") })
          }
        )
      ]
    }
  ) });
}, Y = {
  firstName: "firstName",
  lastName: "lastName",
  city: "city",
  state: "state"
}, Be = (r) => z({
  firstName: P().min(1, { message: r("Mho.PageContent.Profile.EmergencyContact.Validation.FirstName") }).regex(f.name, {
    message: r("Mho.PageContent.Profile.EmergencyContact.Validation.ValidFirstName")
  }),
  lastName: P().min(1, { message: r("Mho.PageContent.Profile.EmergencyContact.Validation.LastName") }).regex(f.name, {
    message: r("Mho.PageContent.Profile.EmergencyContact.Validation.ValidLastName")
  }),
  city: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredCity") }).regex(f.city, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidCity")
  }),
  state: P().min(1, { message: r("MHO.Profile.CarePreferences.Form.Validations.RequiredState") }).regex(f.state, {
    message: r("MHO.Profile.CarePreferences.Form.Validations.ValidState")
  })
}), _e = ({ onSearch: r, onClose: e }) => {
  const { t: s } = g(), [n, t] = M(void 0), o = $(() => Be(s), [s]), c = B({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      city: "",
      state: ""
    },
    resolver: D(o())
  }), { watch: d } = c, u = d(Object.values(Y)).every((i) => i !== "");
  return /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a(
      k,
      {
        className: "mx-3 my-1",
        kind: "error",
        showAlert: !!n,
        durationInSeconds: 10,
        children: n
      }
    ),
    /* @__PURE__ */ a("div", { className: "pt-1 pb-3 overflow-visible", children: /* @__PURE__ */ l(A, { onSubmit: ({ firstName: i, lastName: C, city: F, state: N }) => {
      r({
        firstName: i,
        lastName: C,
        city: F,
        state: N
      });
    }, methods: c, showButtons: !1, children: [
      /* @__PURE__ */ l(A.Row, { className: "gap-3", children: [
        /* @__PURE__ */ a(
          S,
          {
            name: Y.firstName,
            label: s("MHO.Profile.CarePreferences.Form.Labels.Firstname"),
            required: !0
          }
        ),
        /* @__PURE__ */ a(
          S,
          {
            name: Y.lastName,
            label: s("MHO.Profile.CarePreferences.Form.Labels.Lastname"),
            required: !0
          }
        )
      ] }),
      /* @__PURE__ */ a(ue, { setErrorMessage: t }),
      /* @__PURE__ */ a(
        I,
        {
          onCancel: e,
          primaryButton: /* @__PURE__ */ a(O, { type: "submit", kind: "primary", disabled: !u, children: s("MHO.Profile.CarePreferences.Form.Labels.Search") })
        }
      )
    ] }) })
  ] });
}, je = ({
  hasSearchError: r,
  searchResult: e,
  onSelect: s,
  setComponentStep: n
}) => {
  const { t } = g(), { connectedRelUsername: o } = v(), { userMyHealthOneId: c, searchPhysicianErrorMessageField: d, noPhysicianErrorMessageField: m } = x(), u = (i) => {
    const C = {
      user: {
        myHealthOneId: c
      },
      userPhysician: {
        ...i,
        physicianPhone: i.physicianPhone ?? "",
        address: {
          addressLine1: i.address.addressLine1,
          addressLine2: i.address.addressLine2,
          city: i.address.city,
          country: i.address.country ?? "",
          state: i.address.state,
          zip: i.address.zip
        }
      }
    };
    s({ ...C, connectedRelUsername: o });
  }, y = !!e && e.length > 0;
  return /* @__PURE__ */ l(V, { children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: L("pt-1 p-3 overflow-auto", {
          "pb-0 border-top border-neu-gray-20 neu-bg-gray-0": y
        }),
        children: /* @__PURE__ */ l("div", { className: "d-flex flex-column row-gap-3", children: [
          r && !e && /* @__PURE__ */ l("div", { className: "d-flex column-gap-3 p-4 border rounded border-neu-red-60 neu-bg-red-0", children: [
            /* @__PURE__ */ a(ae, { className: "neu-snackbar__feedback-icon", name: "error", color: "red-50" }),
            /* @__PURE__ */ a(R, { field: d })
          ] }),
          /* @__PURE__ */ l("div", { className: "w-100 d-flex flex-row align-items-center justify-content-between", children: [
            /* @__PURE__ */ l("span", { children: [
              e ? e.length : "0",
              " Results Found"
            ] }),
            /* @__PURE__ */ a(
              O,
              {
                className: "link-btn",
                type: "button",
                kind: "tertiary",
                icon: "edit",
                onClick: () => n("searchForm"),
                children: t("MHO.Profile.CarePreferences.Form.Labels.EditSearch")
              }
            )
          ] }),
          y && /* @__PURE__ */ a("div", { className: "d-flex flex-column row-gap-3 pb-3 max-h-224 max-h-272-md", children: e.map((i) => /* @__PURE__ */ a(
            Pe,
            {
              name: `${i.physicianFirstName} ${i.physicianLastName}`,
              address: i.address,
              phone: i.physicianPhone,
              buttonText: "MHO.Profile.CarePreferences.PrimaryCarePhysician.SelectPhysicianText",
              onClick: () => u(i)
            },
            i.nationalProviderIdentifier
          )) })
        ] })
      }
    ),
    /* @__PURE__ */ l(
      "div",
      {
        className: L("pb-3 px-3", {
          "pt-3 border-top border-neu-gray-20": y
        }),
        children: [
          !!e && e.length === 0 && /* @__PURE__ */ a(
            R,
            {
              className: L("mb-5", Q.noItemErrorMessage),
              field: m
            }
          ),
          /* @__PURE__ */ a(
            O,
            {
              kind: "secondary",
              className: "w-100 w-md-auto",
              onClick: () => n("manualAddForm"),
              children: t("MHO.Profile.CarePreferences.PrimaryCarePhysician.NoPhysicianText")
            }
          )
        ]
      }
    )
  ] });
}, Ze = ({ isOpen: r, onClose: e }) => {
  const { t: s } = g(), [n, t] = M("searchForm"), [o, c] = M(""), [d, m] = M(!1), [u, y] = M(null), { showProfileChangeSnackbar: i } = x(), { mutate: C } = De({
    onMutate: () => {
      t("loading");
    },
    onSuccess: (p) => {
      m(!1), y(p.data.results), t("searchList");
    },
    onError: () => {
      m(!0), y(null), t("searchList");
    }
  }), { mutate: F } = ie({
    onMutate: () => {
      t("loading");
    },
    onSuccess: () => {
      e(), i();
    },
    onError: (p) => {
      const H = p;
      c((H == null ? void 0 : H.message) ?? ""), t("manualAddForm");
    }
  }), N = se(() => ({
    loading: {
      label: "",
      component: /* @__PURE__ */ a(T, { className: "pb-6", kind: "spinner" })
    },
    searchForm: {
      label: "MHO.Profile.CarePreferences.PrimaryCarePhysician.FindPhysicianText",
      component: /* @__PURE__ */ a(_e, { onSearch: C, onClose: e })
    },
    searchList: {
      label: "MHO.Profile.CarePreferences.PrimaryCarePhysician.FindPhysicianText",
      component: /* @__PURE__ */ a(
        je,
        {
          hasSearchError: d,
          searchResult: u,
          onSelect: F,
          setComponentStep: t
        }
      )
    },
    manualAddForm: {
      label: "MHO.Profile.CarePreferences.PrimaryCarePhysician.ManuallyAddPhysician",
      component: /* @__PURE__ */ a($e, { onSubmit: F, onClose: e })
    }
  })[n], [n]);
  return q(() => {
    if (r) return;
    const p = setTimeout(() => {
      t("searchForm");
    }, 250);
    return () => clearTimeout(p);
  }, [r]), /* @__PURE__ */ l(
    E,
    {
      active: r,
      onNeuDismiss: e,
      backdropDismiss: !1,
      label: s(N.label),
      size: "large",
      children: [
        /* @__PURE__ */ a(
          k,
          {
            className: "mx-3 my-1",
            kind: "error",
            showAlert: !!o,
            durationInSeconds: 10,
            children: o
          }
        ),
        N.component
      ]
    },
    N.label
  );
}, Ue = (r) => _({
  ...r,
  mutationFn: (e) => me("physician", e.connectedRelUsername)
}), Ye = ({ isOpen: r, onClose: e }) => {
  const { t: s } = g(), { isOnline: n } = ce(), { showProfileChangeSnackbar: t } = x(), { connectedRelUsername: o } = v(), {
    mutate: c,
    isPending: d,
    error: m
  } = Ue({
    onSuccess: () => {
      e(), t();
    }
  });
  return /* @__PURE__ */ l(
    E,
    {
      active: r,
      onNeuDismiss: e,
      backdropDismiss: !d,
      label: s("MHO.Profile.CarePreferences.PrimaryCarePhysician.RemovePhysicianTitle"),
      children: [
        /* @__PURE__ */ a(
          k,
          {
            className: "mx-3 my-1",
            kind: "error",
            showAlert: !!(m != null && m.message),
            durationInSeconds: 10,
            children: m == null ? void 0 : m.message
          }
        ),
        d ? /* @__PURE__ */ a(T, { className: "pb-6", kind: "spinner" }) : /* @__PURE__ */ a(
          fe,
          {
            description: "MHO.Profile.CarePreferences.PrimaryCarePhysician.RemovePhysicianDescription",
            onClose: e,
            onConfirm: n ? () => c({ connectedRelUsername: o }) : () => null
          }
        )
      ]
    }
  );
}, Ge = ({
  physicianTitleValue: r,
  userPhysician: e,
  refetchUserPersonalInformationData: s
}) => {
  const { t: n } = g(), [t, o] = M(!1), [c, d] = M(!1), m = () => {
    s(), d(!1);
  }, u = () => {
    s(), o(!1);
  };
  return /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ a(w, { headerText1: r, children: e ? /* @__PURE__ */ a(
      w.Item,
      {
        itemText1: `${e.physicianFirstName} ${e.physicianLastName}`,
        itemSubText: /* @__PURE__ */ l(V, { children: [
          /* @__PURE__ */ a("p", { children: e.physicianPhone }),
          /* @__PURE__ */ l("p", { className: "text-capitalize", children: [
            e.address.addressLine1,
            " ",
            e.address.addressLine2 && `, ${e.address.addressLine2}`
          ] }),
          /* @__PURE__ */ a("p", { className: "text-capitalize", children: le(e.address) })
        ] }),
        onEditButtonClick: () => o(!0),
        onDeleteButtonClick: () => d(!0)
      }
    ) : /* @__PURE__ */ a(
      w.AddButton,
      {
        text: n("MHO.Profile.CarePreferences.PrimaryCarePhysician.AddPhysicianText"),
        onClick: () => o(!0)
      }
    ) }),
    /* @__PURE__ */ a(Ze, { isOpen: t, onClose: u }),
    /* @__PURE__ */ a(Ye, { isOpen: c, onClose: m })
  ] });
}, Xe = ({ fields: r, rendering: e }) => {
  const { t: s } = g(), { queryParams: n } = v({ levelOfDetail: "FULL" }), {
    data: t,
    refetch: o,
    error: c
  } = Oe({ queryParams: n }), { snackbarProps: d, showSnackbar: m } = Ce(), u = {
    userMyHealthOneId: (t == null ? void 0 : t.user.myHealthOneId) ?? "",
    searchPhysicianErrorMessageField: r.searchPhysicianErrorMessage,
    noPhysicianErrorMessageField: r.noPhysicianErrorMessage,
    searchPharmacyErrorMessageField: r.searchPharmacyErrorMessage,
    noPharmacyErrorMessageField: r.noPharmacyErrorMessage,
    showProfileChangeSnackbar: () => m(
      s("Mho.Profile.ProfileGeneralInformation.PersonalSection.ProfileSuccessfullyChanged")
    )
  };
  return /* @__PURE__ */ a(pe, { className: "p-3", children: /* @__PURE__ */ l(
    ge,
    {
      componentName: e == null ? void 0 : e.componentName,
      level: "2",
      titleClassName: "neu-display-3 fw-bold",
      titleText: r.carePreferencesTitle.value,
      errorMessage: c == null ? void 0 : c.toString(),
      errorDisplayDurationInSeconds: 10,
      descriptionRichText: r.carePreferencesText,
      children: [
        /* @__PURE__ */ a(de.Provider, { value: u, children: /* @__PURE__ */ l("div", { className: "d-flex flex-column row-gap-5 mt-5", children: [
          /* @__PURE__ */ a(
            Ge,
            {
              physicianTitleValue: r.primaryCarePhysicianTitle.value,
              userPhysician: t == null ? void 0 : t.userPhysician,
              refetchUserPersonalInformationData: o
            }
          ),
          /* @__PURE__ */ a(
            ze,
            {
              pharmacyTitleValue: r.pharmacyTitle.value,
              userPharmacy: t == null ? void 0 : t.userPharmacy,
              refetchUserPersonalInformationData: o
            }
          )
        ] }) }),
        /* @__PURE__ */ a(ye, { ...d })
      ]
    }
  ) });
}, pr = be()(
  Xe
);
export {
  pr as MhoCarePreferences
};
